import { Col, Row } from "antd";
import { MarkdownViewer } from "components/assets/utilities/MarkdownViewer";
import { useAppSelector } from "redux/hooks";

const ModelFlowPage = () => {
  const user = useAppSelector((state) => state.user);
  const app = useAppSelector((state) => state.app);

  // user.flow is the raw mermaid source loaded by LoadFlowAction. We wrap it
  // in a fenced code block so MarkdownViewer's MermaidBlock renders it as a
  // diagram instead of as a code block.
  const flowMarkdown = user.flow
    ? "```mermaid\n" + user.flow + "\n```"
    : "";

  return (
    <>
      {app.loading ? <div className="loader-centered"/> :
        <Row>
          <Col md={24}>
            {flowMarkdown
              ? <MarkdownViewer
                  markdown={flowMarkdown}
                  mermaidCollapsible={false}
                />
              : <div style={{ padding: "2em", textAlign: "center", color: "var(--text-color-muted, #888)" }}>
                  No flow diagram available for this model.
                </div>
            }
          </Col>
        </Row>
      }
    </>
  );
};

export default ModelFlowPage;
